/**
 * Milisaniye değerini okunabilir TTL string formatına çevirir
 * @param {number} ms - Milisaniye cinsinden değer
 * @returns {string} Okunabilir TTL string formatı
 */
export const formatTTL = (ms) => {
  if (ms === null || ms === undefined) {
    return 'sınırsız'
  }

  // En uygun birimi seç
  if (ms < 1000) {
    return `${ms}ms`
  } else if (ms < 60 * 1000) {
    return `${Math.round(ms / 1000)}s`
  } else if (ms < 60 * 60 * 1000) {
    return `${Math.round(ms / (60 * 1000))}m`
  } else if (ms < 24 * 60 * 60 * 1000) {
    return `${Math.round(ms / (60 * 60 * 1000))}h`
  } else if (ms < 7 * 24 * 60 * 60 * 1000) {
    return `${Math.round(ms / (24 * 60 * 60 * 1000))}d`
  } else {
    return `${Math.round(ms / (7 * 24 * 60 * 60 * 1000))}w`
  }
}